export const BOOK_APPOINTMENT_START = 'BOOK_APPOINTMENT_START';

export const BOOK_APPOINTMENT_SUCCESS = 'BOOK_APPOINTMENT_SUCCESS';

export const BOOK_APPOINTMENT_FAILURE = 'BOOK_APPOINTMENT_FAILURE';
